import React from "react";
import { FaEllipsisV } from "react-icons/fa";
import { doctorDisplayName, initials } from "../../utils/consultationChatFormat";
import ChatMessageThread from "./ChatMessageThread";
import ChatInputBar from "./ChatInputBar";

const ActiveChatPanel = ({
  doctor,
  showBack,
  onBack,
  chat,
  displayMessages,
}) => {
  const peerName = doctor?.name || "Doctor";
  const {
    staffId,
    loading,
    newMessage,
    setNewMessage,
    file,
    setFile,
    isTyping,
    messagesEndRef,
    fileInputRef,
    sendMessage,
    handleKeyPress,
    remarksMax,
    chatDisabled,
  } = chat;

  return (
    <section className="flex flex-col h-full min-h-0 flex-1 bg-surface-lowest rounded-r-2xl overflow-hidden">
      <header className="bg-[#0B6B53] text-white px-3 md:px-4 py-3 flex items-center justify-between shrink-0">
        <div className="flex items-center gap-2 md:gap-3 min-w-0">
          {showBack && (
            <button
              type="button"
              onClick={onBack}
              className="md:hidden p-2 rounded-full hover:bg-white/10 min-h-[44px] min-w-[44px] flex items-center justify-center shrink-0"
              aria-label="Back to conversations"
            >
              ←
            </button>
          )}
          <div className="relative shrink-0">
            {doctor?.image ? (
              <img src={doctor.image} alt="" className="w-10 h-10 rounded-full object-cover" />
            ) : (
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-sm font-bold">
                {initials(peerName)}
              </div>
            )}
            <span className="absolute bottom-0 right-0 w-2.5 h-2.5 rounded-full bg-green-400 border-2 border-[#0B6B53]" />
          </div>
          <div className="min-w-0">
            <p className="font-semibold text-sm truncate">{doctor ? doctorDisplayName(doctor) : "Select a doctor"}</p>
            <p className="text-xs text-white/85 truncate">
              {doctor?.specialization || "Specialist"}
              {isTyping && " · typing…"}
            </p>
          </div>
        </div>
        {/* <button
          type="button"
          className="p-2 rounded-full hover:bg-white/10 min-h-[44px] min-w-[44px] flex items-center justify-center shrink-0"
          aria-label="Chat options"
        >
          <FaEllipsisV />
        </button> */}
      </header>

      <ChatMessageThread
        displayMessages={displayMessages}
        loading={loading}
        staffId={staffId}
        peerName={peerName}
        messagesEndRef={messagesEndRef}
        chatDisabled={chatDisabled}
      />

      <ChatInputBar
        newMessage={newMessage}
        onMessageChange={setNewMessage}
        onKeyDown={handleKeyPress}
        onSend={sendMessage}
        file={file}
        onFileSelect={setFile}
        onClearFile={() => setFile(null)}
        fileInputRef={fileInputRef}
        chatDisabled={chatDisabled}
        remarksMax={remarksMax}
      />
    </section>
  );
};

export default ActiveChatPanel;
